<script setup lang="ts">
import { onMounted, ref, provide, watch } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useRegionStore } from '@/stores/region';
import AppHeader from '@/components/AppHeader.vue';
import LoginModal from '@/components/LoginModal.vue';
import ProfileModal from '@/components/ProfileModal.vue';
import RegionSetupNotice from '@/components/RegionSetupNotice.vue';

const auth = useAuthStore();
const region = useRegionStore();

const showLogin = ref(false);
const showProfile = ref(false);
/** 未配置区域的提醒面板 */
const showSetupNotice = ref(false);

// 全站统一入口：顶部导航 / 各页面面板的「登录 / 注册」都走这里
provide('openLogin', () => {
  if (!auth.loggedIn) showLogin.value = true;
});

/** 登录后若从未配置过任何区域 → 弹出配置引导 */
watch(() => auth.needsRegionConfig, (need) => {
  if (need) showSetupNotice.value = true;
});

onMounted(async () => {
  // 恢复会话（页面刷新即调用 /api/auth/me）
  await auth.fetchMe();
  // 老用户可能从未配置过区域 → 登录后主动提醒
  if (auth.needsRegionConfig) showSetupNotice.value = true;
  // 加载手写行政区划清单（21 市 + 已资料县区）
  await region.loadAdminDivisions();
  // 扫描 data/ 下所有有 data.js 的目录（动态发现新区域）
  await region.loadManifest();
  // 初始化区域（省默认）
  region.bootstrap();
});
</script>

<template>
  <!-- 全局固定顶部导航（始终在每个路由之上） -->
  <AppHeader @open-login="showLogin = true" @open-profile="showProfile = true" />
  <!-- 路由视图：每个 view 内部都不再渲染 AppHeader，避免重复 -->
  <router-view />
  <!-- 全局登录 / 注册弹窗 -->
  <LoginModal v-model:show="showLogin" />
  <!-- 个人信息面板（普通注册用户） -->
  <ProfileModal v-model:show="showProfile" />
  <!-- 未配置区域的提醒面板 -->
  <RegionSetupNotice v-model:show="showSetupNotice" @open-profile="showProfile = true" />
</template>
